import {useState, useEffect} from 'react'
import { Row, Col, Input, Button, Notification, SelectPicker } from "rsuite";
import Card from './Card.component';
import FieldValidator from './FieldValidator.component';
import UserService from '../services/User.service';
import CepService from '../services/ViaCep.service';
import TeamMemberService from '../services/TeamMember.service';
import { sanitize } from '../pages/Register/components/utils';

const AddressFormCard = ({
  addressData,
  setAddressData,
  hideSaveButton = false,
  onSave,
  onValidityChange
}) => {
  const userService = new UserService();

  const requiredFields = ["zipCode", "addressNumber", "addressName", "city", "addressState", "addressNeighborhood"];

  const buildEmptyValidator = () => ({
    zipCode: { hasError: false, message: "" },
    addressName: { hasError: false, message: "" },
    addressComplement: { hasError: false, message: "" },
    addressNumber: { hasError: false, message: "" },
    addressNeighborhood: { hasError: false, message: "" },
    city: { hasError: false, message: "" },
    addressState: { hasError: false, message: "" },
  });

  const [validator, setValidator] = useState({
    addressUserData: buildEmptyValidator(),
    addressData: buildEmptyValidator(),
  });

  const [addressUserData, setAddressUserData] = useState({
    addressName: "",
    zipCode: "",
    addressNumber: "",
    addressNeighborhood: "",
    city: "",
  })

  const [autoFilledFields, setAutoFilledFields] = useState({
      addressName: true,
      addressNeighborhood: true
  });
  
  const [addressDataButtonLoading, setAddressDataButtonloading] = useState(false)

  const [formChangedAddress, setFormChangedAddress] = useState(false)
  

  const formValidations = (formName, field, value, required = true) => {
    let payload = {}

    if(field === "zipCode"){
        if(sanitize(value).length === 8){
          const currentData = setAddressData ? addressData : addressUserData;

          if(currentData.zipcode !== value)
            getCepAddress(value)
          
        }else{
            payload = {...payload, [formName]: { ...validator[formName], [field]: {hasError: true, message: "Você deve informar um CEP válido"}}}
        }
    }

    if (required && (!value || (typeof value === "string" && !value.trim()))) {
      return {
        [formName]: {
          ...validator[formName],
          [field]: {
            hasError: true,
            message: "Campo obrigatório"
          }
        }
      };
    }

    if (required && (value || (typeof value === "string" && value.trim()))) {
      return {
        [formName]: {
          ...validator[formName],
          [field]: {
            hasError: false,
            message: ""
          }
        }
      };
    }

    // setValidator(prev => ({...prev, addressData: { ...prev.addressData, zipCode: { hasError: false, message: null } } }));

    return payload
  }

  const handleAddressFormChange = async (field, value, required = true) => {
     if (setAddressData) {
      setAddressData({...addressData, [field]: value})     
      setValidator({...validator, ...formValidations("addressData",field, value, required)})  
    } else {
      setFormChangedAddress(true)
      setAddressUserData({...addressUserData, [field]: value})
      setValidator({...validator, ...formValidations("addressUserData",field, value, required)})
    }
  }

  const saveAddressData = async () => {
      setAddressDataButtonloading(true)
      const updated = await userService.put(addressUserData,'user/address/update')
      if(updated){
          Notification['success']({
              title: 'Sucesso',
              description: <p>Os dados foram atualizados com sucesso!</p>
          });
      }
      await loadAddressData();
      setAddressDataButtonloading(false)
      setFormChangedAddress(false)

  }

  const loadAddressData = async () => {
    if (!setAddressData) {
      const response = await userService.get('user/get/address')
      setAddressUserData(response)
    }
  }

  const disableMenuForRole = (role) => {
      const hasAccess = new TeamMemberService().evaluateRole(role)
      return !hasAccess
  }

  const getCepAddress = async (cep, target = "user", silent = false) => {
    const cepService = new CepService();
      try{
        const cepResponse = await cepService.find(cep);

        if(cepResponse && !cepResponse.erro) {
          const payload = {
              zipCode: cep,
              addressName: cepResponse.logradouro || "", 
              city: cepResponse.localidade || "", 
              addressNeighborhood: cepResponse.bairro || "",  
              addressState: cepResponse.uf || "",
              address: `${cepResponse.logradouro || ""}, ${cepResponse.localidade || ""} - ${cepResponse.uf || ""}`
          }

          setAutoFilledFields({
              addressName: !!cepResponse.logradouro,
              addressNeighborhood: !!cepResponse.bairro
          });

          if (silent) return payload;

          if (setAddressData) {
            setAddressData({ ...addressData, ...payload });
            setValidator(prev => ({...prev, addressData: { ...prev.addressData, zipCode: { hasError: false, message: null } } }));
          }else{
            setAddressUserData({ ...addressUserData, ...payload });
            setValidator(prev => ({ ...prev, addressUserData: { ...prev.addressUserData, zipCode: { hasError: false, message: null } }}));
          }
        } else {
          setValidator(prev => ({ ...prev,
            [setAddressData ? "addressData" : "addressUserData"]: { 
              ...prev[setAddressData ? "addressData" : "addressUserData"], 
              zipCode: { hasError: true, message: "CEP inválido" } 
            } 
          }));
        }
      } catch {
        setValidator(prev => ({ 
          ...prev,
          [setAddressData ? "addressData" : "addressUserData"]: { 
            ...prev[setAddressData ? "addressData" : "addressUserData"], 
            zipCode: { hasError: true, message: "Erro ao buscar CEP" } 
          }
        }));
      }
  }

  useEffect(() => {
        loadAddressData();
  }, [])

  useEffect(() => {
    if (typeof onSave === "function") {
      onSave(() => saveAddressData);
    }
  }, [onSave, addressUserData]);

  useEffect(() => {
    let valid

    if(addressData){
      valid = requiredFields.some(
        field => {
          const value = addressData[field];
          return !value || (typeof value === "string" && !value.trim());
        }
      )
    }else{
      valid = requiredFields.some(
        field => {
          const value = addressUserData[field];
          return !value || (typeof value === "string" && !value.trim());
        }
      )
    }
    if (onValidityChange) {
      onValidityChange(valid);
    }
  }, [addressUserData, addressData]);

  const currentValidator = setAddressData
    ? validator.addressData
    : validator.addressUserData;

  const states = [
    { label: "AC", value: "AC" },
    { label: "AL", value: "AL" },
    { label: "AP", value: "AP" },
    { label: "AM", value: "AM" },
    { label: "BA", value: "BA" },
    { label: "CE", value: "CE" },
    { label: "DF", value: "DF" },
    { label: "ES", value: "ES" },
    { label: "GO", value: "GO" },
    { label: "MA", value: "MA" },
    { label: "MT", value: "MT" },
    { label: "MS", value: "MS" },
    { label: "MG", value: "MG" },
    { label: "PA", value: "PA" },
    { label: "PB", value: "PB" },
    { label: "PR", value: "PR" },
    { label: "PE", value: "PE" },
    { label: "PI", value: "PI" },
    { label: "RJ", value: "RJ" },
    { label: "RN", value: "RN" },
    { label: "RS", value: "RS" },
    { label: "RO", value: "RO" },
    { label: "RR", value: "RR" },
    { label: "SC", value: "SC" },
    { label: "SP", value: "SP" },
    { label: "SE", value: "SE" },
    { label: "TO", value: "TO" },
  ];

  return <>
    <Row style={{marginTop: '5px'}}>
        <Col lg={6}>
            <p style={{marginBottom: '6px', paddingLeft: '3px'}}>CEP <small className="label link" style={{fontSize: '.8em'}}><a href="https://buscacepinter.correios.com.br/app/endereco/index.php?t" target="_blank">Não sei meu CEP</a></small></p>
            <Input 
                disabled={disableMenuForRole("my_account.update")}
                value={addressData?.zipCode || addressUserData.zipCode} 
                onChange={(event) => {handleAddressFormChange("zipCode", event, true)}} 
            />
            <FieldValidator field="zipCode" validator={currentValidator} />
        </Col>
        <Col lg={18}>
            <p style={{marginBottom: '6px', paddingLeft: '3px'}}>Rua</p>
            <Input 
                disabled={disableMenuForRole("my_account.update")}
                value={addressData?.addressName || addressUserData.addressName} 
                onChange={(event) => {handleAddressFormChange("addressName", event, true)}} 
                />
            <FieldValidator field="addressName" validator={currentValidator} />
        </Col>
    </Row>

    <Row style={{marginTop: '15px'}}>
        <Col lg={20}>
            <p style={{marginBottom: '6px', paddingLeft: '3px'}}>Complemento</p>
            <Input 
                disabled={disableMenuForRole("my_account.update")}
                value={addressData?.addressComplement || addressUserData.addressComplement} 
                onChange={(event) => {handleAddressFormChange("addressComplement", event, true)}} 
                />
            <FieldValidator field="addressComplement" validator={currentValidator} />
        </Col>

        <Col lg={4}>
            <p style={{marginBottom: '6px', paddingLeft: '3px'}}>Número</p>
            <Input 
                disabled={disableMenuForRole("my_account.update")}
                value={addressData?.addressNumber || addressUserData.addressNumber} 
                onChange={(event) => {handleAddressFormChange("addressNumber", event, true)}} 
                />
            <FieldValidator field="addressNumber" validator={currentValidator} />
        </Col>
    </Row>

    <Row style={{marginTop: '15px'}}>
        <Col lg={10}>
            <p style={{marginBottom: '6px', paddingLeft: '3px'}}>Bairro</p>
            <Input 
                disabled={disableMenuForRole("my_account.update")}
                value={addressData?.addressNeighborhood || addressUserData.addressNeighborhood} 
                onChange={(event) => {handleAddressFormChange("addressNeighborhood", event, true)}} 
                />
            <FieldValidator field="addressNeighborhood" validator={currentValidator} />
        </Col>

        <Col lg={10}>
            <p style={{marginBottom: '6px', paddingLeft: '3px'}}>Cidade</p>
            <Input 
                disabled={disableMenuForRole("my_account.update")}
                value={addressData?.city || addressUserData.city} 
                onChange={(event) => {handleAddressFormChange("city", event, true)}} 
                />
            <FieldValidator field="city" validator={currentValidator} />
        </Col>

        <Col lg={4}>
            <p style={{marginBottom: '6px', paddingLeft: '3px'}}>Estado</p>
            <SelectPicker
                data={states}
                style={{ width: '100%' }}
                searchable
                placeholder="Estado"
                value={addressData?.addressState || addressUserData.addressState}
                onChange={(event) => {handleAddressFormChange("addressState", event, true)}} 
                disabled={disableMenuForRole("my_account.update")}
            />
            <FieldValidator field="addressState" validator={currentValidator} />
        </Col>
    </Row>
    {
      !hideSaveButton ? 
      <>
        <Row style={{marginTop: '15px'}}>
            <Col lg={24} style={{display: 'flex', justifyContent: 'flex-end'}}>
                <Button 
                  appearance="primary" 
                  loading={addressDataButtonLoading} 
                  onClick={saveAddressData} 
                  disabled={
                    requiredFields.some(
                      field => {
                        const value = addressUserData[field];
                        return !value || (typeof value === "string" && !value.trim());
                      }
                    ) ||
                    formChangedAddress === false}
                    >
                  Salvar Alterações
                </Button>
            </Col>
        </Row>
      </> : null
    }
  </>
};

export default AddressFormCard;